import * as Sentry from "@sentry/react"

/**
 * Initialises Sentry only when `VITE_SENTRY_DSN` is set, so the app is fully
 * functional (and adds zero network traffic) without it. Wire a real DSN in the
 * deploy environment to start receiving client errors.
 */
export function initSentry(): void {
    const dsn = import.meta.env.VITE_SENTRY_DSN
    if (!dsn) return

    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
        // Error reporting only for now — no performance/session tracing.
        tracesSampleRate: 0,
    })
}

/** Report a caught error. No-op when Sentry isn't initialised. */
export function captureError(error: unknown, context?: Record<string, unknown>): void {
    if (!import.meta.env.VITE_SENTRY_DSN) return
    Sentry.captureException(error, context ? { extra: context } : undefined)
}
